
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0m4,5.5a1.75,1.75,0,1,1-1.75,1.75A1.75,1.75,0,0,1,16,5.5M10.5,6A2.5,2.5,0,1,1,8,8.5,2.5,2.5,0,0,1,10.5,6m4.42,10.683c-1.851,1.754-6.986,1.758-8.838,0S7.088,12.042,10.5,12c3.387.04,6.271,2.929,4.42,4.683m4.18-3.406a4.129,4.129,0,0,1-2.355.874,6.031,6.031,0,0,0-3.515-3.108A4.3,4.3,0,0,1,16,10c2.376.026,4.4,2.049,3.1,3.277"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  